import styled from 'styled-components'

const Ellipsis = styled.p`
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  display: inline-block;
`

export default Ellipsis
